import { Routes } from '@angular/router';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';
import { CourseDetailsComponent } from './modules/details/course/course.component';
import { EventDetailsComponent } from './modules/details/event/event.component';
import { OrderProcessComponent } from './modules/order-process/order-process.component';
import { PortalBookingErrorComponent } from './modules/portal-booking-error/portal-booking-error.component';
import { PortalLegalPageComponent } from './modules/portal-legal-page/portal-legal-page.component';
import { PartnerPortalComponent } from './partner-portal.component';
import { PortalAppComponent } from './portal-app.component';

export const portalAppRoutes: Routes = [
    {
        path: '',
        component: PortalAppComponent,
        children: [
            {
                path: '',
                component: PartnerPortalComponent
            },
            {
                path: 'home',
                component: PartnerPortalComponent
            },
            {
                path: 'account',
                loadChildren: () => import('../partner-portal/modules/account/account.module').then((m) => m.AccountModule)
            },
            {
                path: 'order-process',
                component: OrderProcessComponent
            },
            {
                path: 'event-detail/:id',
                component: EventDetailsComponent
            },
            {
                path: 'course-detail/:id',
                component: CourseDetailsComponent
            },
            { path: 'revocation', component: PortalLegalPageComponent },
            { path: 'terms', component: PortalLegalPageComponent },
            { path: 'disclaimer', component: PortalLegalPageComponent },
            { path: 'booking-error', component: PortalBookingErrorComponent }
        ]
    },
    { path: '**', component: PageNotFoundComponent }
];
